/* eslint-disable jsx-a11y/media-has-caption */
import { PlayCircleOutlined } from '@ant-design/icons';
import { List, Modal as OrdModal } from 'antd';
import moment from 'moment';
import { SubThemeType } from 'pages/WebinarsPage/model/WebinarsType';
import React, { FC, ReactNode, useEffect, useState } from 'react';
import './VideoModal.style.less';
import { useSearchParams } from 'react-router-dom';

interface ModalProps {
  url: string;
  ordAttribute: string;
  subThemes: SubThemeType[];
  youtubeVideo?: ReactNode;
  description?: ReactNode;
  theme: string;
}

const VideoModal: FC<ModalProps> = (props) => {
  const [videoOpen, setVideoOpen] = useState<boolean>(false);
  const { url, subThemes, ordAttribute, youtubeVideo, description, theme } = props;
  const [urlParams, setUrlParams] = useSearchParams();
  const onCancelHandler = () => {
    setVideoOpen(false);
    urlParams.delete('theme');
    setUrlParams(urlParams)
  };
  useEffect(() => {
    if (urlParams.get('theme') === theme) {
      setVideoOpen(true);
    }
  }, [urlParams.get('theme')])
  return (
    <>
      <PlayCircleOutlined
        onClick={() => {
          setVideoOpen(true);
          urlParams.set('theme', theme)
          setUrlParams(urlParams)
        }}
        style={{ fontSize: '17rem' }}
        className="modal-open--icon"
        data-ord-attribute={ordAttribute}
      />
      <OrdModal
        open={videoOpen}
        footer={null}
        destroyOnClose
        onCancel={(e) => {
          e.stopPropagation();
          onCancelHandler();
        }}
        width={1000}
        key={url}
      >
        {youtubeVideo || (
          <video src={url} controls id={url} className="video">
            К сожалению, ваш браузер не поддерживает встроенные видео, но не
            волнуйтесь, вы можете{' '}
            <a href={url} download>
              скачать
            </a>
            и смотрите его в своем любимом видеоплеере!
          </video>
        )}
        {description && description}
        {subThemes.length > 0 && (
          <List
            dataSource={subThemes}
            size="small"
            header="Обсуждаемые вопросы"
            renderItem={(item) => (
              <List.Item>
                {`${item.text} `}
                {item.timeCode && (
                  <button
                    type="button"
                    className="btn-timecode"
                    onClick={(event) => {
                      event.preventDefault();
                      const video: HTMLMediaElement = document.getElementById(
                        url,
                      ) as HTMLMediaElement;
                      video.currentTime = item.timeCode as number;
                    }}
                  >
                    {` ${moment.utc(item.timeCode * 1000).format('HH:mm:ss')}`}
                  </button>
                )}
              </List.Item>
            )}
          />
        )}
      </OrdModal>
    </>
  );
};

export default VideoModal;
